module.exports = __webpack_public_path__ + "static/media/hemi_head_bd_it-webfont.72b0936c.woff";